module.exports = __webpack_public_path__ + "static/ImageOurExpertise-33b6dcac2c4411728b9b85000283d3a0.jpg";